import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { FaVideo } from "react-icons/fa"
import { ResourceType } from "../Interfaces"
import { VideoPlayer } from "@/components/Resource/Components/VideoPlayer"

// Video Dialog Component - separate to avoid event conflicts
export function VideoDialog({ 
    isOpen, 
    type,
    onClose, 
    fileName 
}: { 
    isOpen: boolean; 
    type: ResourceType;
    onClose: () => void; 
    fileName: string; 
}) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="max-w-4xl w-full h-auto">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2">
                        <FaVideo className="w-5 h-5 text-purple-500" />
                        {fileName}
                    </DialogTitle>
                </DialogHeader>
                <div className="mt-4">
                    {isOpen && (
                        <VideoPlayer fileName={fileName} location={`resources/${type}`} />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    )
}
